import type { CookieAttributes } from "js-cookie";

export const createForm = (data: any) => {
    const formData = new FormData();
    Object.keys(data).map((key) => {
        if (Array.isArray(data[key]) && data[key][0] && data[key][0] instanceof File) {
            for (let i = 0; i < data[key].length; i++) {
                formData.append(key, data[key][i]);
            }
        } else {
            if (data[key] !== null && data[key] !== undefined) {
                formData.append(key, data[key]);
            }
        }
    })
    return formData
}

export const secureCookieOptions: CookieAttributes = {
    secure: window.location.protocol === "https:",
    sameSite: "strict",
};
